import Grid from "../Grid/Grid";
import Card from "../Card/Card";
import SEO from "../SEO/SEO";

function BlogOverview({ data, category, search, additionalFunction, title }) {
  return (
    <>
      <SEO
        title={title}
        keywords={category}
        description={category}
        type={category}
        url={window.location.href}
      />
      <Grid>
        {data?.length > 0 &&
          data.map((el) => (
            <Card
              key={el?.key}
              blogId={el?.key}
              image={el?.image}
              title={el?.title}
              text={el?.text}
              author={el?.author}
              releaseDate={el?.releaseDate}
              category={search ? el?.searchlink : category}
              data={el}
              search={search}
              additionalFunction={additionalFunction}
            />
          ))}
      </Grid>
    </>
  );
}

export default BlogOverview;
